
let titlePicto = {
    init() {
        if($('body').hasClass('page-node-type-homepage') ||
            $('body').hasClass('page-node-type-marque') ||
            $('body').hasClass('page-node-type-landing') ){
            this.title();
        }
    },
    title() {
        $('.block-page-title .pictoh1').remove();
        $('.block-page-title br').before('<span class="pictoh1"></span>');
    }
}

export default titlePicto;
